var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnsActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#6C42A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9H7.907l1.794-1.793L9 6.5l-3 3 3 3 .701-.707L7.91 10H14a3 3 0 0 1 0 6h-4v1h4a4 4 0 1 0 0-8z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnsActiveIcon);
export default __webpack_public_path__ + "static/media/returnsActiveIcon.e6e1a62e96df3a8aa01a8322ec9d3079.svg";
export { ForwardRef as ReactComponent };